import React, { useState } from "react";
import DatePicker from 'react-datepicker'
import './MahutiCalender.css';
import he from 'date-fns/locale/he'
import { format, getDate, getMonth, getYear } from "date-fns";
import { useDispatch, useSelector } from "react-redux";
import { setActivityDate, setRefresh } from "../../store/MahutiReducer";
import { getTicketsSF } from "../../utils/sfUtils";
import { useEffect } from "react";
import { getLocalStoragKey } from "../../store/mahutiLocalStorage";
import { LOCAL_STORAGE_STEP } from "../../utils/GlobalParams";




export default function MahutiCalender(props) {

  const dispatch = useDispatch();
  const store = useSelector(store => store.reducer);
  const [selectedDate, setSelectedDate] = useState(props.activityDates[0]?.activityDate ? new Date(props.activityDates[0]?.activityDate) : undefined);
  const localStorageActivityDate = getLocalStoragKey(LOCAL_STORAGE_STEP, 'activityDate')

  useEffect(() => {
    !store.activityEditMode && removeSelectedActivityOnLoad()
    dispatch(setRefresh(false))
    init();
  }, [])

  const init = () => {
    
    if (localStorageActivityDate) {
      let visitorsSUM = (props.visitors?.underAge || 0) + (props.visitors?.adults || 0)

      setSelectedDate(new Date(localStorageActivityDate));
      getTicketsSF(localStorageActivityDate, props.productId, store.lpName || undefined)
        .then(res => {
          //first selected
          props.setTicketsAvailable(res.data);
          props.validateTicketsNumber(res.data, visitorsSUM, localStorageActivityDate);

        }).catch(err => {
          props.setErrorMessageHead('לא נמצאו כרטיסים')
        })
    }
  }

  const removeSelectedActivityOnLoad = () => {
    let selectedActivityDay = document.getElementsByClassName('react-datepicker__day--selected');
    if(selectedActivityDay.length > 0){
      if (selectedActivityDay[0].classList.contains('react-datepicker__day--selected')) {
        let element = selectedActivityDay[0]
        element.classList.remove('react-datepicker__day--selected');
        dispatch(setActivityDate(undefined))
        element.addEventListener('click', () => {
          dateChange(selectedDate); 
          element.classList.add('react-datepicker__day--selected');})
      } 
    }
  }

  // const renderDayContents = (day, date) => {
  //   return <span className="datepicker_dayWrapper">{getDate(date)}</span>;
  // }

  const renderDayContents = (day, date) => {
    const isEnabled = enableDates(date);
    return (
      <span 
        className="datepicker_dayWrapper"
        tabIndex={isEnabled ? 0 : -1}
        role="button"
        onKeyDown={(e) => handleKeyDown(e, date)}
        aria-label={`בחר ${format(date, 'dd/MM/yyyy')}`}
      >
        {getDate(date)}
      </span>
    );
  };

  const handleKeyDown = (event, date) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      dateChange(date);
    }
  };

  const renderWeekDayName = (date) => <span className="datepicker_dayWrapper day_name" >{format(date, 'EE')}</span>;

  const highlightWithRanges = [{
    'react-datepicker__day--highlighted-mahuti': [

    ]
  }]



  const enableDates = (date) => {

    const availableDates = props.activityDates
    const day = getDate(date);
    const month = getMonth(date);
    const year = getYear(date);

    return availableDates.find(item => {
      const d = new Date(item.activityDate);
      // console.log(day, month, year , 'with', day, month, year);
      return getDate(d) === day && getMonth(d) === month && getYear(d) === year;
    }) ? true : false
  }

  const dateChange = (date) => {
    let month_ready = date.getMonth() + 1
    const month = month_ready < 10 ? '0' + month_ready : month_ready;
    const day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    const year = date.getFullYear();
    const d = year + '-' + month + '-' + day;
    let visitorsSUM = (props.visitors?.underAge || 0) + (props.visitors?.adults || 0)

    setSelectedDate(date);
    getTicketsSF(d, props.productId, store.lpName || undefined).then(res => {
      //first selected
      props.setTicketsAvailable(res.data);
      props.validateTicketsNumber(res.data, visitorsSUM, d)
      props.setErrorMessageHead(undefined)

    }).catch(err => {
      props.setErrorMessageHead('לא נמצאו כרטיסים לתאריך המבוקש')

    })

    dispatch(setActivityDate(d));
  }

  const renderCustomHeader = ({
    date, 
    decreaseMonth,
    increaseMonth,
  }) => ( 
    <div class="react-datepicker__header ">
      <div class="react-datepicker__current-month">{format(date, 'MMMM yyyy', { locale: he })}</div>
      <div class="react-datepicker__header__dropdown react-datepicker__header__dropdown--scroll"></div>
      <button type="button" class="react-datepicker__navigation react-datepicker__navigation--previous" onClick={decreaseMonth} aria-label="לחודש הקודם"><span class="react-datepicker__navigation-icon react-datepicker__navigation-icon--previous">לחודש הקודם</span></button>
      <button type="button" class="react-datepicker__navigation react-datepicker__navigation--next" onClick={increaseMonth} aria-label="לחודש הבא"><span class="react-datepicker__navigation-icon react-datepicker__navigation-icon--next">לחודש הבא</span></button>
    </div>
  )

  return <div>
    <DatePicker
      inline
      isClearabledate
      size="lg"
      formatWeekDay={renderWeekDayName}
      highlightDates={highlightWithRanges}
      wrapperClassName="mahutiCalender"
      locale={he}
      selected={selectedDate}
      onChange={(date) => dateChange(date)}
      renderDayContents={renderDayContents}
      filterDate={enableDates}
      renderCustomHeader={renderCustomHeader}
    />
    <p className="align-items-center calendar-helptext text-start text-mahuti d-flex border border-end-0 border-start-0 border-top-0 pb-lg-3 pb-0 mt-3 mt-lg-4">
      <i className="circle-shape circle me-2"/>
      <span className="note_size">ימים בהם מתקיימות פעילויות</span>
    </p>

  </div>
}